import axiosInstance from '@/lib/axiosInstance';
import { AxiosPromise } from 'axios';

export interface ApplyCouponParams {
  code: string;
}

export interface ApplyCouponResponse {
  success: boolean;
  message?: string;
}

export interface CouponHistoryItem {
  id: string;
  code: string;
  amount: number;
  status: 'applied' | 'expired' | 'invalid';
  applied_at: string;
  expired_at?: string;
}

export interface GetCouponHistoryResponse {
  data: CouponHistoryItem[];
  has_more: boolean;
}

export interface GetCouponHistoryParams {
  limit?: number;
  startAfter?: string;
}

export const applyCoupon = (
  data: ApplyCouponParams
): AxiosPromise<ApplyCouponResponse> => {
  // TODO: Replace with actual API endpoint
  return axiosInstance.post('/coupon/apply', data);
};

export const getCouponHistory = async (
  params?: GetCouponHistoryParams
): Promise<GetCouponHistoryResponse> => {
  // TODO: Replace with actual API endpoint
  const { data } = await axiosInstance.get<GetCouponHistoryResponse>(
    '/coupon/history',
    { params }
  );
  return data;
};
